module.exports = __webpack_public_path__ + "media/images/landing_page/banners/banner_two-555064acffa77b20579ed24a7b795b9d.jpg";